export const ApeTraitRarity = {
    common: 'common',
    epic: 'epic',
    legendary: 'legendary',
    og: 'og mint',
}